import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useRef } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  CircularProgress,
  Grid,
  Menu,
  MenuItem,
  ListItemText,
  List,
  Badge,
  TextField,
  Divider,
  Popover,
  Tabs,
  Tab,
  Box
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user/list';
import  CustomerOrderToolbar  from 'src/components/_dashboard/user/list/CustomerOrderToolbar';
import  ProductsMenu  from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import {COMPANY_NAME, REST_API, REST_API_END_POINT} from '../../constants/Defaultvalues';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup';
import OfficialCard from 'src/components/_dashboard/official-request/OfficialCard';
import CommunityCard from 'src/pages/dashboard/CommunityCard'
import ClientProjectCard from './ClientProjectCard';
import { KeyboardArrowLeft, KeyboardBackspaceOutlined, ExpandLess, ExpandMore, ViewModule, ViewList, List as ListIcon, UploadFile, FilterList } from '@material-ui/icons';
import { styled } from '@material-ui/styles';
import CommunityListGrid from 'src/pages/dashboard/communityLIstGrid';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'logo', label: 'Logo', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'type', label: 'Type', alignRight: false },
  { id: 'phone', label: 'Phone', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'addedby', label: 'Added By', alignRight: false },
  { id: 'addedon', label: 'Added On', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'options', label: '', alignRight: false},      
];

// id,name,description	,	type,phone,email,address, thumbnail, status, authorized_by, timestamp
// ----------------------------------------------------------------------

const SORT = [
  { id: 'new', label: 'Newest', color: '#54D62C' },
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
]

const CustomTab = styled(Tab)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  boxShadow: 'none',
  minHeight: 'fit-content',
  indicator: {
    display: 'none',
  },
  height: 38,
  fontSize: 12,
  borderRadius: 'none',
  border: '1.5px solid #00c2ff',
  background: '#161c24',
  margin: 0,
  color: theme.palette.text.primary,
  '&:hover': {
    background: '#161c24',
  },
  '&.Mui-selected': {
    background: theme.palette.primary.main,
    color: '#fff',
  },
  '&:first-child': {
    borderRadius: '7px 0 0 7px',
    borderLeft: `1.5px solid ${theme.palette.primary.main}`,
  },
  '&:nth-child(2)': {
    borderRadius: '0',
    borderLeft: '0',
  },
  '&:nth-child(3)': {
    borderRadius: '0',
    borderLeft: '0',
  },
  '&:last-child': {
    borderRadius: '0 7px 7px 0',
    borderLeft: '0',
  },
  [theme.breakpoints.up('lg')]: {
    marginRight: `0 !important`,
    minWidth: '20% !important',
  },
  [theme.breakpoints.down('lg')]: {
    marginRight: `0 !important`,
    minWidth: '20% !important',
  },
  [theme.breakpoints.down('sm')]: {
    marginRight: `0 !important`,
    minWidth: '30.33% !important',
  },
}))

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}


export default function ClientProjectList(props) {
    const location = useLocation();
    const clientId = location.state && location.state.id;
  const theme = useTheme();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [communityList, setCommunityList] = useState([]);
  const [openDeletePop,setOpenDeletePop] =useState(false);
  const [deletingId,setDeletingId] = useState();
  const [deletingName,setDeletingName] = useState('');
  const user = JSON.parse(localStorage.getItem('user'))
  const userId = user.user_id
  const userType = user.user_type
  const receivedData = location.state;
  const explodedPermissions = user?.exploded_permissions;
  const [sort, setSort] = useState(SORT[0])
  const [sortOpen, setSortOpen] = useState(false)
  const refSort = useRef(null)
  const [clientsOpen, setClientsOpen] = useState(false)
  const [clientData, setClientData] = useState([])
  const [filterClient, setFilterClient] = useState([])
  const [clientSearchTerm, setClientSearchTerm] = useState('')
  const refClients = useRef(null)
  const [salesRepsOpen, setSalesRepsOpen] = useState(false)
  const [salesRepData, setSalesRepData] = useState([])
  const [filterSalesRep, setFilterSalesRep] = useState([])
  const [salesRepSearchTerm, setSalesRepSearchTerm] = useState('')
  const refSalesReps = useRef(null)
  const refSettings = useRef(null)
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null)
  const isFiltersOpen = Boolean(filtersAnchorEl)
  const [viewTab, setViewTab] = useState('one')
  const isClient = user?.isClient;

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  // Fetch view type from backend
  const fetchViewType = async () => {
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      const res = await axios.post(`${REST_API_END_POINT}get-community-view-type`, { userId });
      if (res.data?.status === 1 && res.data?.data?.viewType !== undefined) {
        setViewTab(res.data.data.viewType);
      }
    } catch (error) {
      console.error('Error fetching community view type:', error);
    }
  };
  
  // Load view type from backend on mount
  useEffect(() => {
    if (user?.user_id || user?.id) {
      fetchViewType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true)
    try{
    //   const response = await axios.post(`${REST_API_END_POINT}community/get-all-communities`)
    const response = await axios.post(`${REST_API}webservice/rfq/get-project-by-client`,{clientId, userId, userType})
      const communityListData = response?.data?.data;
      if(communityListData){
        // setCommunityList(communityListData);
        // console.log("communityList : ",communityList);

        const response = await axios.post(
          `${REST_API_END_POINT}community/get-all-communities`,
          {sort: sort?.id || "new",filterClient:[receivedData?.client_id], clientId:user?.client_id, userType, filterSalesRep}
        )
        const communityCountData = response?.data?.results
        
        // Fetch client and sales rep data for filters
        if (!user.isVendor && user.user_type !== 3 && !isClient) {
          try {
            const [clientsRes, salesRepRes] = await Promise.all([
              axios.post(`${REST_API_END_POINT}client/get-all-clients`),
              axios.post(`${REST_API_END_POINT}user/get-all-sales-reps`)
            ]);
            if (clientsRes?.data?.status === 1) {
              setClientData(clientsRes.data.data || []);
            }
            if (salesRepRes?.data?.status === 1) {
              setSalesRepData(salesRepRes.data.data || []);
            }
          } catch (error) {
            console.error('Error fetching filter data:', error);
          }
        }

        const tempCommunityList = [];

        communityListData?.map(item=>{
          const data = communityCountData?.find(community=>community?.id == item?.id)
          item.no_of_requests = data?.no_of_requests || 0
          item.no_of_projects = data?.no_of_projects || 0
          item.no_of_installs = data?.no_of_installs || 0
          item.no_of_pickups = data?.no_of_pickups || 0
          item.no_of_shippings = data?.no_of_shippings || 0
          item.no_of_designs = data?.no_of_designs || 0
          item.no_of_estimates = data?.no_of_estimates || 0

          tempCommunityList.push(item);
        })


        // await Promise.all(
        //   communityListData.map(async (data) => {
        //     try {
        //       // const hasPermission = explodedPermissions?.some(permission => ['View Projects'].includes(permission)) || false;
        //       const [requestResponse, projectResponse , installsResponse , designResponse] = await Promise.all([
        //         axios.post(`${REST_API}webservice/rfq/get-request-by-community`, {
        //           communityId: data?.id,
        //           userId: clientId,
        //           userType : 3,
        //           hasPermission : false,
        //         }),
        //         userType != 3 ?
        //         axios.post(`${REST_API}webservice/rfq/get-project-by-community`, {
        //           communityId: data?.id,
        //           userId: clientId,
        //           userType : 3,
        //           hasPermission : false,
        //         }) : Promise.resolve(null),
        //         axios.post(`${REST_API}webservice/rfq/get-installs-by-community`, {
        //           communityId: data?.id,
        //           userId: clientId,
        //           userType : 3,
        //           hasPermission : false,
        //         }),
        //         axios.post(`${REST_API}webservice/rfq/get-design-by-community`, {
        //           communityId: data?.id,
        //           userId: clientId,
        //           userType : 3,
        //           hasPermission : false,
        //         }),
        //       ]);
        //       let clientsArray = data?.client_user_ids?.split(',');
        //       let userExistsInClients = clientsArray?.includes(userId.toString());
        //       data.flag = userExistsInClients ? 1 : 0;
        //       if (requestResponse.data) {
        //         const request = requestResponse.data.data;
        //         data.requestCount = request?.length || 0;
        //         data.no_of_requests = request?.length || 0;
        //       }else{
        //         data.requestCount = 0;
        //         data.no_of_requests = 0;
        //       }
  
        //       if (projectResponse?.data) {
        //         const project = projectResponse.data.data;
        //         data.projectCount = project?.length || 0;
        //         data.no_of_projects = project?.length || 0;
        //       } else {
        //         data.projectCount = 0;
        //         data.no_of_projects = 0;
        //       }
              
        //       if(installsResponse.data){
        //         const installs = installsResponse.data?.data;
        //         data.installsCount = installsResponse.data?.totalCount || 0;
        //         data.no_of_installs = installsResponse.data?.totalCount || 0;
        //       }else{
        //         data.installsCount = 0;
        //         data.no_of_installs = 0;
        //       }

        //       if(designResponse.data){
        //         const designs = designResponse.data?.data;
        //         data.designsCount = designResponse.data?.totalCount || 0;
        //         data.no_of_designs = designResponse.data?.totalCount || 0;
        //       }else{
        //         data.designsCount = 0;
        //         data.no_of_designs = 0;
        //       }
        //       tempCommunityList.push(data);
        //     } catch (error) {
        //       console.error(`Error processing community ID ${data?.id}:`, error);
        //     }
        //   })
        // );
        setCommunityList(tempCommunityList);
      }
      else{
        setCommunityList([]);
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
      setLoading(false);
    }
  }
  useEffect(() => {
      fetchData();
  }, [receivedData, sort, filterClient, filterSalesRep]);

  // Refresh data when coming back from edit
  useEffect(() => {
    if (location.state?.refresh) {
      fetchData();
      // Clear the refresh flag
      navigate(location.pathname, { state: receivedData, replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.refresh]);

  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const changeStatus = async (comId, comStatus) => {
    try {
      let deleteId = comId;
      let status = comStatus;
      let response = await axios.post(`${REST_API_END_POINT}community/delete-community`,{deleteId,status,userId});
    //   console.log("response-----------------", response.data);
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
      }
      else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Server Error...!", { variant: 'error' });
        navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuClick = async (id, status) => {
    let newStatus;
    (status === 1) ? newStatus = 0 : newStatus = 1
    // console.log("id, newStatus",id, newStatus);
    await changeStatus(id, newStatus);
  }

  const handleDeleteClick = async (id, newStatus) => {
    // console.log("id, newStatus",id, newStatus);
    setDeletingName('');
    setDeletingId();
    setOpenDeletePop(false);
    await changeStatus(id, newStatus);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0)
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const handleChangeSort = (category) => {
    setSort(category)
    setSortOpen(false)
  }

  const handleOpenFilters = (event) => {
    setFiltersAnchorEl(event.currentTarget)
  }

  const handleCloseFilters = () => {
    setFiltersAnchorEl(null)
    setClientsOpen(false)
    setSortOpen(false)
    setSalesRepsOpen(false)
  }

  const handleChangeView = async (event, newValue) => {
    setViewTab(newValue);
    
    // Save view type to backend
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      await axios.post(`${REST_API_END_POINT}update-community-view-type`, { 
        userId, 
        viewType: newValue 
      });
    } catch (error) {
      console.error('Error updating community view type:', error);
    }
  }

  function handleToggleClient(id) {
    setFilterClient((prevIds) => {
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

  function handleToggleSalesRep(id) {
    setFilterSalesRep((prevIds) => {
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

  console.log('receivedData====',receivedData)

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - communityList?.length) : 0;
  
  // Apply sorting
  let filteredUsers = [...communityList];
  if (sort?.id === 'custom_order') {
    filteredUsers = filteredUsers.sort((a, b) =>
      (a.name || '').localeCompare(b.name || '', undefined, { numeric: true, sensitivity: 'base' })
    )
  } else if (sort?.id === 'new') {
    filteredUsers = applySortFilter(filteredUsers, getComparator('desc', 'id'), '');
  } else if (sort?.id === 'old') {
    filteredUsers = applySortFilter(filteredUsers, getComparator('asc', 'id'), '');
  }
  
  // Apply search filter
  if (filterName) {
    filteredUsers = filteredUsers.filter((item) =>
      item.name?.toLowerCase().includes(filterName.toLowerCase()) ||
      item.description?.toLowerCase().includes(filterName.toLowerCase()) ||
      item.type?.toLowerCase().includes(filterName.toLowerCase())
    );
  }
  
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = filteredUsers?.length === 0;
  const activeView = viewTab || 'one';

  return (
    <Page title={`All Projects | ${COMPANY_NAME}`}>
      <Container>
        {/* <Card> */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          <Stack direction="row" alignItems="center" sx={{ gap: 2 }}>
            <Button
              sx={{ mb: 0 }}
              size="small"
              component={RouterLink}
              to={PATH_DASHBOARD.client.cards}
              variant="outlined"
              startIcon={
                <Stack>
                  <KeyboardBackspaceOutlined />
                </Stack>
              }
            >
              Back to All Clients
            </Button>
            <HeaderBreadcrumbs heading={`${receivedData?.name} - Projects` || 'Projects'} />
          </Stack>
          <Stack direction="column" spacing={2}>
            <Button
              ref={refSettings}
              onClick={handleOpenFilters}
              variant="contained"
              color="success"
              sx={{
                color: 'common.white',
              }}
              startIcon={<FilterList />}
            >
              Filters
            </Button>
            <Stack direction="row" spacing={2} alignItems="center">
              <Button
                disabled={explodedPermissions?.some(permission => ['Add Projects'].includes(permission)) ? false : true}
                onClick={() => {
                  navigate(PATH_DASHBOARD.community.create, { state: { fromClientProject: true, clientData: receivedData } })
                }}
                variant="outlined"
                startIcon={<Icon icon={plusFill} />}
              >
                Add Project
              </Button>
              <Button
                disabled={explodedPermissions?.some(permission => ['Add Projects'].includes(permission)) ? false : true}
                onClick={() => {
                  navigate(PATH_DASHBOARD.community.uploadProjects)
                }}
                variant="outlined"
                startIcon={<UploadFile />}
              >
                Upload Projects
              </Button>
            </Stack>
          </Stack>
        </Stack>

        <Popover
          open={isFiltersOpen}
          anchorEl={filtersAnchorEl}
          onClose={handleCloseFilters}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              width: { xs: '92vw', sm: 620, md: 780 },
              maxWidth: '92vw',
              p: 2,
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Tabs
                value={viewTab}
                onChange={handleChangeView}
                textColor="secondary"
                indicatorColor="none"
                aria-label="view tabs"
                sx={{ mb: { xs: 1, md: 0 } }}
              >
                <CustomTab value="one" icon={<ViewModule />} />
                <CustomTab value="two" icon={<ViewList />} />
                <CustomTab value="three" icon={<ListIcon />} />
              </Tabs>
            </Grid>

            {!user.isVendor && user.user_type !==3 && !isClient && (
              <Grid item xs={12} sm={4}>
                <Badge
                  badgeContent={filterClient?.length}
                  color="warning"
                  invisible={filterClient?.length === 0}
                >
                  <Button
                    fullWidth
                    ref={refClients}
                    onClick={() =>
                      setClientsOpen((prevState) => !prevState)
                    }
                    variant={filterClient?.length > 0 ? 'contained' : 'outlined'}
                    type="submit"
                    sx={{ alignItems: 'flex-end' }}
                    endIcon={
                      <Stack>
                        {clientsOpen ? (
                          <ExpandLess sx={{ ml: 'auto' }} />
                        ) : (
                          <ExpandMore sx={{ ml: 'auto' }} />
                        )}
                      </Stack>
                    }
                  >
                    Filter By Client
                  </Button>
                </Badge>
                <Menu
                  open={Boolean(clientsOpen)}
                  anchorEl={refClients.current}
                  onClose={() => setClientsOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%' },
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <Box sx={{ p: 2, pb: 1 }}>
                    <TextField
                      size="small"
                      placeholder="Search clients..."
                      value={clientSearchTerm}
                      onChange={(e) => setClientSearchTerm(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mb: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }}/>
                  </Box>
                  <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {(() => {
                      const filteredClients = clientData?.filter((type) =>
                        type.name?.toLowerCase().includes(clientSearchTerm.toLowerCase())
                      ) || [];
                      
                      const sortedClients = filteredClients.sort((a, b) => {
                        const nameA = (a.name || '').trim();
                        const nameB = (b.name || '').trim();
                        return nameA.localeCompare(nameB, undefined, { 
                          numeric: true, 
                          sensitivity: 'base' 
                        });
                      });
                      
                      if (sortedClients.length === 0 && clientSearchTerm) {
                        return (
                          <MenuItem disabled sx={{ justifyContent: 'center' }}>
                            <ListItemText 
                              primary="No result found" 
                              sx={{ textAlign: 'center' }}
                            />
                          </MenuItem>
                        );
                      }
                      
                      return sortedClients.map((type) => (
                        <MenuItem key={type.id}>
                          <ListItemText primary={`${type.name}`} />
                          <Checkbox
                            checked={filterClient.includes(type.id)}
                            onChange={() => {
                              handleToggleClient(type.id)
                            }}
                          />
                        </MenuItem>
                      ));
                    })()}
                  </List>
                </Menu>
              </Grid>
            )}

            {!user.isVendor && user.user_type !==3 && !isClient && (
              <Grid item xs={12} sm={4}>
                <Badge
                  badgeContent={filterSalesRep?.length}
                  color="warning"
                  invisible={filterSalesRep?.length === 0}
                >
                  <Button
                    fullWidth
                    ref={refSalesReps}
                    onClick={() =>
                      setSalesRepsOpen((prevState) => !prevState)
                    }
                    variant={filterSalesRep?.length > 0 ? 'contained' : 'outlined'}
                    type="submit"
                    sx={{ alignItems: 'flex-end' }}
                    endIcon={
                      <Stack>
                        {salesRepsOpen ? (
                          <ExpandLess sx={{ ml: 'auto' }} />
                        ) : (
                          <ExpandMore sx={{ ml: 'auto' }} />
                        )}
                      </Stack>
                    }
                  >
                    Filter By Sales Rep
                  </Button>
                </Badge>
                <Menu
                  open={Boolean(salesRepsOpen)}
                  anchorEl={refSalesReps.current}
                  onClose={() => setSalesRepsOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%' },
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <Box sx={{ p: 2, pb: 1 }}>
                    <TextField
                      size="small"
                      placeholder="Search sales reps..."
                      value={salesRepSearchTerm}
                      onChange={(e) => setSalesRepSearchTerm(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mb: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }}/>
                  </Box>
                  <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {(() => {
                      const filteredSalesReps = salesRepData?.filter((rep) =>
                        rep.userName?.toLowerCase().includes(salesRepSearchTerm.toLowerCase())
                      ) || [];
                      
                      const sortedSalesReps = filteredSalesReps.sort((a, b) => {
                        const nameA = (a.userName || '').trim();
                        const nameB = (b.userName || '').trim();
                        return nameA.localeCompare(nameB, undefined, { 
                          numeric: true, 
                          sensitivity: 'base' 
                        });
                      });
                      
                      if (sortedSalesReps.length === 0 && salesRepSearchTerm) {
                        return (
                          <MenuItem disabled sx={{ justifyContent: 'center' }}>
                            <ListItemText 
                              primary="No result found" 
                              sx={{ textAlign: 'center' }}
                            />
                          </MenuItem>
                        );
                      }
                      
                      return sortedSalesReps.map((rep) => (
                        <MenuItem key={rep.id}>
                          <ListItemText primary={rep.userName} />
                          <Checkbox
                            checked={filterSalesRep.includes(rep.id)}
                            onChange={() => {
                              handleToggleSalesRep(rep.id)
                            }}
                          />
                        </MenuItem>
                      ));
                    })()}
                  </List>
                </Menu>
              </Grid>
            )}

            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                ref={refSort}
                onClick={() => setSortOpen((prevState) => !prevState)}
                variant="outlined"
                type="button"
                endIcon={
                  <Stack>
                    {sortOpen ? (
                      <ExpandLess sx={{ ml: 'auto' }} />
                    ) : (
                      <ExpandMore sx={{ ml: 'auto' }} />
                    )}
                  </Stack>
                }
              >
                {sort.label}
              </Button>
              <Menu
                open={Boolean(sortOpen)}
                anchorEl={refSort.current}
                onClose={() => setSortOpen(false)}
                PaperProps={{
                  sx: {
                    width: 'auto',
                    maxWidth: '100%',
                    maxHeight: '250px',
                  },
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                {SORT.map((category) => (
                  <MenuItem
                    key={category.id}
                    onClick={() => handleChangeSort(category)}
                  >
                    <ListItemText primary={category.label} />
                  </MenuItem>
                ))}
              </Menu>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                onClick={()=>{
                  navigate(PATH_DASHBOARD.community.type)
                }}
                variant="contained"
              >
                Project Types
              </Button>
            </Grid>
            <Grid item xs={12}>
              {filterClient?.length > 0 && (
                <Button
                  variant="outlined"
                  sx={{
                    color: 'white',
                    borderColor: 'primary.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                    marginRight: 2,
                    marginBottom: 2,
                  }}
                >
                  <span
                    style={{
                      color: theme.palette.primary.darker,
                      marginRight: 8,
                    }}
                  >
                    Selected Clients{' '}
                  </span>
                  {clientData
                    .filter((client) => filterClient?.includes(client.id))
                    .map((client) => client.name)
                    .join(', ')}
                </Button>
              )}
              {filterSalesRep?.length > 0 && (
                <Button
                  variant="outlined"
                  sx={{
                    color: 'white',
                    borderColor: 'primary.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                    marginRight: 2,
                    marginBottom: 2,
                  }}
                >
                  <span
                    style={{
                      color: theme.palette.primary.darker,
                      marginRight: 8,
                    }}
                  >
                    Selected Sales Reps{' '}
                  </span>
                  {salesRepData
                    .filter((rep) => filterSalesRep?.includes(rep.id))
                    .map((rep) => rep.userName)
                    .join(', ')}
                </Button>
              )}
            </Grid>
          </Grid>
        </Popover>

        <CustomerOrderToolbar 
          filterName={filterName} 
          onFilterName={handleFilterByName} 
          item="project"
        />

          {activeView === 'one' && (
            <>
              <Scrollbar>
                {loading ?
                  <CircularProgress color="primary" variant="indeterminate" />
                :
                <Grid container
                sx={{
                  display: 'grid',
                  gap: 1.5,
                  gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(4, minmax(0, 1fr))',
                    lg: 'repeat(4, minmax(0, 1fr))',
                    xl: 'repeat(6, minmax(0, 1fr))',
                  },
                  justifyContent: 'center',
                  mb: 2,
                }}>
                  {filteredUsers?.length>0 && slicedData.map((row) => {
                    return (
                      <Grid key={row.id} item>
                        <CommunityCard card={row} isVendor={true} clientProject={true} clientData={receivedData} onRefresh={fetchData} key={row.id} />
                      </Grid>
                    )
                  })}
                </Grid>
                }
              </Scrollbar>
              <TablePagination
                rowsPerPageOptions={[12, 24, 48]}
                component="div"
                count={filteredUsers?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
          {activeView === 'two' &&
            <CommunityListGrid
              projectData={filteredUsers}
              totalCount={filteredUsers?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              sort={sort}
              clientProjectBackState={receivedData}
            />}
          {activeView === 'three' &&
            <CommunityListGrid
              noImage={true}
              projectData={filteredUsers}
              totalCount={filteredUsers?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              sort={sort}
              clientProjectBackState={receivedData}
            />}
        {/* </Card> */}
      </Container>

      {/* Confirmation for deleting community */}
      <ConfirmationPopup
        open={openDeletePop}
        handleClose={()=>{setOpenDeletePop(false)}}
        message={`You want to delete ${deletingName} ! `}
        handleClick={()=>{handleDeleteClick(deletingId, 2)}}
      />
    </Page>
  );
}
